(function () {
  'use strict';

  const SCROLL_DEBOUNCE = 300;
  let scrollTimer = null;
  let isUserScrolling = false;

  const widget = document.getElementById('palora-gift-widget');
  const popup = document.getElementById('palora-gift-popup');
  const overlay = document.getElementById('palora-gift-overlay');

  if (!widget) return;

  // Move to body to fix fixed positioning
  document.body.appendChild(popup);
  document.body.appendChild(overlay);

  // Scroll: hide on scroll, show when stopped
  window.addEventListener('scroll', () => {
    if (!isUserScrolling) {
      isUserScrolling = true;
      widget.classList.add('is-hidden');
    }
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      isUserScrolling = false;
      widget.classList.remove('is-hidden');
    }, SCROLL_DEBOUNCE);
  }, { passive: true });

  // Open popup
  widget.addEventListener('click', () => {
    popup.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  // Close popup
  function closePopup() {
    popup.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.getElementById('palora-gift-close').addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePopup(); });

})();
